export default "__VITE_ASSET__D_7Aid9i__"